<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.BANKS"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            :add-rules="addRules"
            :title='$t("catalogPage.pageTitleBanks")'/>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "Banks",
        title() {
            return this.$t("catalogPage.pageTitleBanks");
        },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("catalogPage.colName"),
                    "created_at": this.$t("catalogPage.colCreatedAt"),
                    "updated_at": this.$t("catalogPage.colUpdatedAt")
                }
            },
            addRules() {
                return {
                    name: [val => !!val || this.$t("catalogPage.ruleRequired")]
                }
            }
        }
    }
</script>

<style scoped>

</style>
